<template>
    <div class="trainer__edit">
        <div class="trainer__edit_header">
            <view-actions
                :title="`${$t('ebs.trainers.edit.title.editing')} ${trainerName}`"
                :notify-title="$t('ebs.trainers.edit.title.notifyTitle')"
                :notify-process="$t('ebs.trainers.edit.title.stopProcess')"
                :cancel-button-text="$t('ebs.trainers.edit.buttons.stop')"
                :submit-button-active="false"
                :trash-button-active="isSecondStageTokenFromOldLMS"
                @emit-notify-remove-submit="trainerRemove"
                @emit-notify-cancel-submit="trainerStopEdit"
            />
        </div>
        <div class="trainer__edit_main">
            <div class="container">
                <div class="columns">
                    <div class="column is-5-desktop is-12-tablet is-12-mobile">
                        <trainer-edit-form/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import TrainerEditForm from '@/components/ebs/trainers/edit/TrainerEditForm'

export default {
  components: {
    TrainerEditForm,
    ViewActions
  },
  name: 'trainer-edit',
  computed: {
    isSecondStageTokenFromOldLMS () {
      return this.$store.getters.getAuthUserIsSecondStageTokenOldLMS
    },
    trainerName: function () {
      return this.$store.getters['getTrainerName']
    }
  },
  methods: {
    allowRedirectBeforeRouteLeave: function () {
      this.$eventBus.$emit('trainer-submit')
    },
    //
    trainerRemove: function () {
      this.allowRedirectBeforeRouteLeave()
      this.$store.dispatch('removeTrainer', this.$route.params.id)
    },
    trainerStopEdit: function () {
      this.$store.dispatch('resetTrainer')
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'ebs-trainer-show', params: { id: this.$route.params.id } })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/trainers/traineraddedit";
</style>
